import { HTMLAttributes } from 'react';
import { Button } from '@/components/common/Button/Button';
import { cn } from '@/utils/cn';

interface StartupPlanProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonHref?: string;
}

export const StartupPlan = ({
  title = 'Startup Plan 🚀',
  description = 'Are you a startup? We offer customized plans for early-stage startups for their unique use-cases. Click on the link to take advantage of our startup program designed to help you grow and succeed.',
  buttonText = 'Apply Now',
  buttonHref = 'https://cal.com/cobalt/welcome-to-cobalt',
  className,
  ...props
}: StartupPlanProps) => {
  return (
    <section
      className={cn(
        'py-10 md:py-16 bg-gray-950 text-white rounded-2xl',
        className
      )}
      {...props}
    >
      <div className="container mx-auto px-4 text-center max-w-3xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">{title}</h2>

        <p className="text-base md:text-lg mb-6 md:mb-8 text-gray-200 mx-auto max-w-md md:max-w-2xl">
          {description}
        </p>

        <div className="flex justify-center">
          <Button
            variant="solid"
            color="primary"
            size="lg"
            onClick={() => window.open(buttonHref, '_blank')}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </section>
  );
};